<template>
  <div class="groupType" v-if="this.items.length > 1 ">
    <span>Groupes</span>
    <select multiple @change="$emit('change', $event)">
      <option v-for="item in items" :key="item.id" :value="item.id" :title="item.name+' ['+item.id+']'">{{ item.name }}</option>
    </select>
  </div>
</template>

<script>
export default {
  name: 'SportGamesFiltersDayGroupType',
  computed: {
    items () {
      const filter = this.$store.getters['Sport/GroupType/filtered']
      return this.$store.getters['Sport/GroupType/list'].filter(item => filter.indexOf(item.id) > -1)
    }
  }
}
</script>

<style scoped>
  .groupType{
    display:flex;
    align-items:center;
    margin-bottom:10px;
    flex-direction:column;
    align-items: stretch
  }
  .groupType > span{
    font-size:14px;
    margin-bottom:5px
  }
  .groupType > select{
    height:80px;
    flex:0 0 100%
  }
</style>
